import label from "@/lang/StaticLabels.js";

export default {
  scmsSetting: (state) => {
    return state.scmsSetting;
  },

  buyFactor: (state) => {
    return state.buyFactor;
  },
  buyFactorById: (state) => {
    return state.buyFactorById;
  },
  buyFactorId: (state) => {
    return state.buyFactorId;
  },
  buyFactorMaxCode: (state) => {
    return state.buyFactorMaxCode;
  },
  buyFactorAttachment: (state) => {
    return state.buyFactorAttachment;
  },
  buyFactorAttachmentById: (state) => {
    return state.buyFactorAttachmentById;
  },
  buyFactorAddMinus: (state) => {
    return state.buyFactorAddMinus;
  },

  readBuyRequestByCode: (state) => {
    state.readBuyRequestByCode.forEach(func);
    function func(item) {
      item.subUnitCount = item.subCount;
      item.buyRequestCode = item.reqBuyCode;
      item.buyRequestCommodityId = item.id;
      item.totalCount = item.remain;
      item.mainCount = item.remain;
    }
    return state.readBuyRequestByCode;
  },

  readBuyRequestByCommodityOptions: (state) => {
    const readBuyRequestByCommodityOptions = [];
    state.readBuyRequestByCommodity.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.reqBuyCode,
        dateLocal: item.dateLocal,
        remain: item.remain,
        confirmTotalCount: item.confirmTotalCount,
        buyFactorWithoutReceiptTotalCount:
          item.buyFactorWithoutReceiptTotalCount,
      };
      readBuyRequestByCommodityOptions.push(pushItem);
    }
    return readBuyRequestByCommodityOptions;
  },

  returnBuyFactor: (state) => {
    return state.returnBuyFactor;
  },
  returnBuyFactorById: (state) => {
    return state.returnBuyFactorById;
  },
  returnBuyFactorId: (state) => {
    return state.returnBuyFactorId;
  },
  returnBuyFactorMaxCode: (state) => {
    return state.returnBuyFactorMaxCode;
  },
  returnBuyFactorAttachment: (state) => {
    return state.returnBuyFactorAttachment;
  },
  returnBuyFactorAttachmentById: (state) => {
    return state.returnBuyFactorAttachmentById;
  },
  returnBuyNotes: (state) => {
    return state.returnBuyNotes;
  },

  latestBuyPriceOfCommodityReport: (state) => {
    return state.latestBuyPriceOfCommodityReport;
  },
  factorComprehensiveReport: (state) => {
    return state.factorComprehensiveReport;
  },
  commodityComprehensiveReport: (state) => {
    return state.commodityComprehensiveReport;
  },
  monthlyPurchaseSomeReport: (state) => {
    return state.monthlyPurchaseSomeReport;
  },
  monthlyPurchaseMonetaryReport: (state) => {
    return state.monthlyPurchaseMonetaryReport;
  },

  buyNotes: (state) => {
    return state.buyNotes;
  },

  buyReportBySuppliers: (state) => {
    return state.buyReportBySuppliers;
  },
  buyReportBySuppliersFactorList: (state) => {
    return state.buyReportBySuppliersFactorList;
  },
  buyReportBySuppliersCommodityList: (state) => {
    return state.buyReportBySuppliersCommodityList;
  },
  buyReportBySuppliersAddMinusList: (state) => {
    return state.buyReportBySuppliersAddMinusList;
  },

  buyFactorManagementCartable: (state) => {
    return state.buyFactorManagementCartable;
  },
  buyReturnManagementCartable: (state) => {
    return state.buyReturnManagementCartable;
  },
  reqBuyManagementCartable: (state) => {
    return state.reqBuyManagementCartable;
  },

  reqBuyCartable: (state) => {
    state.reqBuyCartable.forEach(func);
    function func(item) {
      item.confirmMainCount = item.mainCount;
      item.confirmSubCount = item.subCount;
      item.confirmTotalCount = item.totalCount;
    }
    return state.reqBuyCartable;
  },

  buyFactorCartable: (state) => {
    return state.buyFactorCartable;
  },

  returnBuyFactorCartable: (state) => {
    return state.returnBuyFactorCartable;
  },

  factorCalculate: (state) => {
    return state.factorCalculate;
  },

  factorAddMinus: (state) => {
    return state.factorAddMinus;
  },

  factorCalculateAddMinus: (state) => {
    return state.factorCalculateAddMinus;
  },

  cartableLog: (state) => {
    return state.cartableLog;
  },

  buyFactorVoucher: (state) => {
    return state.buyFactorVoucher;
  },

  printLink: (state) => {
    return state.printLink;
  },

  returnBuyFactorVoucher: (state) => {
    return state.returnBuyFactorVoucher;
  },
  readBuyFactor: (state) => {
    return state.readBuyFactor;
  },

  buyFactorGroupReceiptCartable: (state) => {
    return state.buyFactorGroupReceiptCartable;
  },

  returnBuyFactorGroupDraftCartable: (state) => {
    return state.returnBuyFactorGroupDraftCartable;
  },

  // Static Getters ---------------------------------------------------------------
  buyFactorActions() {
    return [
      {
        subItems: [
          { value: 1, title: label.button.addAccountingVoucher },
          { value: 2, title: label.button.deleteAccountingVoucher },
        ],
      },
      {
        subItems: [{ value: 3, title: label.caption.reReadBuyRequest }],
      },
    ];
  },

  returnBuyFactorActions() {
    return [
      {
        subItems: [
          { value: 1, title: label.button.addAccountingVoucher },
          { value: 2, title: label.button.deleteAccountingVoucher },
        ],
      },
      {
        subItems: [{ value: 3, title: label.caption.reReadBuyFactor }],
      },
    ];
  },
};
